import { useEffect, useState } from "react";
import { useFormik } from 'formik';
import useAxios from "./useAxios";
import { toaster } from '../utils/toast';
import Constants from "../Constants";
import * as Yup from 'yup';
import LoggedInUserService from '../services/AuthService'

const useProfile = () => {
    const { putData } = useAxios()
    const [user, setUser] = useState({
        firstName: "",
        lastName: "",
        email: "",
    })

    useEffect(() => {
        const data = LoggedInUserService.GetLoggedInUserData();
        setUser(data)
    }, [])

    const validationSchema = Yup.object().shape({
        email: Yup.string().required('Email is required').email('Please enter a valid email'),
        firstName: Yup.string().required('First name is required'),
        lastName: Yup.string().required('Last name is required'),
    })

    const onSubmit = async (values) => {
        const payload = {
            'firstName': values?.firstName,
            'lastName': values?.lastName,
            'email': values?.email,
        }

        await putData(Constants.ApiUrl.user.updateProfile, payload).then((res) => {
            if (res?.success) {
                toaster({ message: 'Profile updated successfully', success: true });
            }
            LoggedInUserService.UpdateLoggedInUserSession(res?.token);
        }).catch(err => {
            console.log('error in update the user profile', err);
            toaster({ message: 'Failed to update profile', success: false });
        });
    }

    const formik = useFormik({
        initialValues: { ...user },
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    return {
        formik,
    }

}

export default useProfile
